import * as actionTypes from './actionTypes';
import IPretendente from '../interfaces/IPretendente';

export const salvarConjugeSucesso = (dadosConjuge: IPretendente) =>
  ({ type: actionTypes.SALVAR_CONJUGE_SUCESSO, state: dadosConjuge });

export const carregarConjuge = (dadosConjuge: IPretendente) =>
  ({ type: actionTypes.CARREGAR_CONJUGE, state: dadosConjuge });